/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { Document } from '@zapier/common-components';
import { Button, Spacer, Surface, Text } from '@zapier/design-system';
import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks';
import { SuccessModal } from './SuccessModal';
import { createNewAccount as CreateNewAccountData } from './types/createNewAccount';
import { makeGqlMock } from '@zapier/design-system-revenue/src/mocks';

const Styles = {
  outerContainer: css`
    max-width: 600px;
    margin: 30px auto;
  `,

  innerContainer: css`
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  `,
};

export const CREATE_ACCOUNT_MUTATION = gql`
  mutation createNewAccount($accountId: ID!) {
    createNewFreeAccount(currentAccountId: $accountId) {
      id
    }
  }
`;

export const CreateNewAccount = () => {
  const { accountId } = useCurrentAccountId();
  const [createAccount, { data, loading }] = useMutation<CreateNewAccountData>(
    CREATE_ACCOUNT_MUTATION,
    {
      variables: { accountId },
    }
  );

  return (
    <Document title="Create a new account">
      {data && !loading && (
        <SuccessModal accountId={data.createNewFreeAccount.id} />
      )}
      <div css={Styles.outerContainer}>
        <Surface borderColor="grey300">
          <div css={Styles.innerContainer}>
            <Text tag="h2" textAlign="center" type="header800">
              Create new account
            </Text>

            <Spacer height={30} />

            <Text tag="p" type="bodyText800">
              You are creating a new account on a free ($0 USD) plan.
            </Text>

            <Spacer height={30} />

            <Button disabled={loading} onClick={() => createAccount()}>
              Create
            </Button>
          </div>
        </Surface>
      </div>
    </Document>
  );
};

export const createNewAccountMock = makeGqlMock(
  {
    query: CREATE_ACCOUNT_MUTATION,
    variables: { accountId: 1 },
  },
  {
    createNewFreeAccount: {
      __typename: 'Account',
      id: 100,
    },
  }
);
